import { Outlet } from 'react-router-dom'
import { Container, Stack } from '@mui/material'
import useOffSetTop from '../../hooks/useOffSetTop'
import { HEADER } from '../../config-global'
import Header from './Header'
import { MenuBrandingProvider } from './MenuBrandingContext'
import { MenuThemeProvider } from './MenuThemeProvider'
import { MenuCartStickyBar } from './MenuCartStickyBar'

export default function MenuLayout() {
    const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP)

    return (
        <MenuBrandingProvider>
            <MenuThemeProvider>
                <Header isOffset={isOffset} />
                <Container id="app-container" component="main">
                    <Stack
                        sx={{
                            py: { xs: 10, md: 12 },
                            pb: { xs: 14, md: 14 },
                            minHeight: '100vh',
                        }}
                    >
                        <Outlet />
                    </Stack>
                </Container>
                <MenuCartStickyBar />
            </MenuThemeProvider>
        </MenuBrandingProvider>
    )
}
